export default __webpack_public_path__ + "static/char-17-anr-42b98ddedd353b41a05cd9ba35226fc2.gif";